export default __webpack_public_path__ + "static/media/weather_app.35af87b4.png";